export default {
  siteId: "2",
  siteName: "de",
  site: "de",
  lang: "German",
  langCode: "de-DE",
  activityName: "leave_a_review",
  productList: "Produktliste",
  POST: "POST",
  Score: "Note",
  Title: "Titel",
  Review: "Bewertung",
  Media: "Medien",
  MediaType: "Unterstützte Dateitypen sind JPEG, JPG, PNG oder MP4.",
  MediaReward:
    "Bilder oder Videos teilen, um besondere Belohnungen freizuschalten.",
  RewardQa:
    "Beantworten Sie alle unten stehenden Fragen für zusätzliche Belohnungen.",
  MoreQa: "Klicken Sie, um weitere Fragen auszufüllen.",
  RewardsToast:
    "Ihre Belohnung wurde erfolgreich auf Ihr Konto gutgeschrieben.",
  rateLevel1: "Sehr unzufrieden",
  rateLevel2: "Etwas unzufrieden",
  rateLevel3: "Weder zufrieden noch unzufrieden",
  rateLevel4: "Überwiegend zufrieden",
  rateLevel5: "Sehr zufrieden",
  "LEAVE A REVIEW": "Schreiben Sie bitte eine Bewertung",
  "Please enter a star rating for this review":
    "Bitte geben Sie eine Sternebeurteilung ab",
  "Review’s title can’t be empty":
    "Der Titel der Bewertung darf nicht leer sein",
  "Review’s body can’t be empty": "Der Text der Bewertung darf nicht leer sein",
  "Please upload a media less than 10 megabytes":
    "Bitte laden Sie ein Medium mit weniger als 10 Megabyte hoch",
  "Please upload a media less than 20 megabytes":
    "Bitte laden Sie ein Medium mit weniger als 20 Megabyte hoch",
  "THANK YOU FOR YOUR COMMENTS": "Vielen Dank für Ihre Bewertung",
  "We love seeing reviews":
    "Wir danken Ihnen für Ihre wertvolle Zeit, um uns ein detailliertes und konstruktives Feedback zu geben.",
  "fill out":
    "Bitte füllen Sie das folgende Formular aus und geben Sie Ihre Bewertung ab.",
  "SUBMIT YOUR REVIEW": "Bewertung veröffentlichen",
  shopping:
    "https://de.cupshe.com/collections/alle-bademode?utm_source=automatic&utm_medium=email&utm_campaign=review_shopping",
  mailto: "customercare",
  pageTitle: "Kundenbewertungen",
  "VIEW COMMENTS": "Bewertungen anschauen",
  "GO SHOPPING": "Jetzt shoppen",
  mailText: `Um sicherzustellen, dass Sie unsere E-Mail-Updates erhalten, fügen Sie bitte <a style="color:#333;text-decoration: underline;" class="c-muli-light" href="mailto:{mailto}{domain}">{mailto}{domain}</a> zu Ihrem Adressbuch hinzu.`,
  email: "E-Mail",
  "contact us": "Kontakt uns",
  contactUrl:
    "https://de.cupshe.com/pages/kontaktieren-uns?utm_source=automatic&utm_medium=email&utm_campaign=review_contact",
  next: "das nächste",
  copyright: "Copyright © {year} Cupshe {sitename}, Alle Rechte vorbehalten.",
  subscribe1:
    "Sie haben sich erfolgreich von den Marketing-Nachrichten von Cupshe DE abgemeldet.",
  subscribe2: "Wollten Sie sich nicht abmelden?",
  subscribe3: "ERNEUT ANMELDEN",
  subscribe4:
    "Sie haben sich erfolgreich erneut für die Werbenachrichten von Cupshe Deutschland angemeldet.",
  "You're already on the list!": "Sie sind bereits angemeldet!",
  "Oops, there was a hiccup!Please try again.":
    "Ups! Ein Problem ist aufgetreten! Bitte versuchen Sie es erneut.",
  unsubscribe: "abbestellen",
  continuesubscribe: "WEITER ABONNIEREN",
  trustsubscribe:
    "Vielen Dank für Ihr Vertrauen, wir werden Ihnen bessere Dienstleistungen und günstigere Produkte bieten.",
  mailContact:
    'Bitte wenden Sie sich an den <a href="https://de.cupshe.com/pages/contact-us" class="contact_link">Customer Service</a>.',
  policyText:
    "*Bitte beachten Sie, dass Sie nach Ihrer Abmeldung möglicherweise E-Mails mit vertraglichen Informationen über Ihre zukünftigen Online-Einkäufe erhalten. Zum Beispiel Bestellbestätigung, Versandbenachrichtigung, Rückerstattungsbenachrichtigung, usw.).",
};
